import { combineReducers } from 'redux'

import deleteNode from './locations/delete'
import get from './locations/get'
import list from './locations/list'
import post from './locations/post'
import put from './locations/put'
import reorder from './locations/reorder'
import view from './locations/view'

export default combineReducers({
  delete: deleteNode,
  get,
  list,
  post,
  put,
  reorder,
  view
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/locations.js